import { LangActions, LANG_ACTION_TYPE } from './lang-type';
import { RootState } from '../root-reducer';

export enum LANG_STATE_KEY {
  LANG = 'lang',
}

export type LangState = {
  [LANG_STATE_KEY.LANG]?: string,
};

const initialState: LangState = {

};

export const langReducers = (state = initialState, action: LangActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case LANG_ACTION_TYPE.CHANGE_LANGUAGE:
      return {
        ...state,
        [LANG_STATE_KEY.LANG]: action.payload.data,
      };
    default:
      return state;
  }
};

export const langStateSelector = (key: LANG_STATE_KEY) => (state: RootState) => state.lang[key];
